import { render, staticRenderFns } from "./order_migrate_detail.vue?vue&type=template&id=727ad60f&scoped=true&"
import script from "./order_migrate_detail.vue?vue&type=script&lang=js&"
export * from "./order_migrate_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727ad60f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('727ad60f')) {
      api.createRecord('727ad60f', component.options)
    } else {
      api.reload('727ad60f', component.options)
    }
    module.hot.accept("./order_migrate_detail.vue?vue&type=template&id=727ad60f&scoped=true&", function () {
      api.rerender('727ad60f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/net_bar/order/order_migrate_detail.vue"
export default component.exports